import api from '@/api'

export default {
  namespaced: true,
  state: {
    profile: null,
    password_required: false,
    password_invalid: false,
    password: ''
  },
  getters: {
    isOwner(state, getters, rootState) {
      if (!rootState.account.account) {
        return false;
      }
      if (!state.profile) {
        return false;
      }
      if (rootState.account.account.uid === state.profile.account.uid) {
        return true
      }
      return false
    },
    profileVideo: (state) => (section) => {
      if (!state.profile) {
        return null;
      }
      return state.profile.profile_videos.find(v => {
        return v.section === section
      })
    }
  },
  mutations: {
    profile_loaded(state, data) {
      state.profile = data;
    },
    projects_loaded(state, data) {
      state.projects = data
    },
    set_password(state, password) {
      state.password = password;
    }
  },
  actions: {
    clear_password(context) {
      context.state.password = null
    },
    async load(context, uid) {
      let profile = await api({
        method: "POST",
        url: `/view-profile`,
        data: {
          uid: uid,
          password: context.state.password
        }
      })
      if (profile.password_required) {
        context.state.profile = null
        context.state.password_required = true
      } else if (profile.password_invalid) {
        context.state.profile = null
        context.state.password_invalid = true;
        context.state.password_required = true
      } else {
        context.state.password_invalid = false
        context.state.password_required = false
        context.commit('profile_loaded', profile)
      }

    }
  },
}
